module.exports = __webpack_public_path__ + "img/scissors.8343d320.png";